/** Units a number field can show next to its value. The key is what the form builder saves in `config.unit`. */
export const UNITS: Record<string, { ar: string; en: string }> = {
  // area
  m2: { ar: 'م²', en: 'm²' },
  dunum: { ar: 'دونم', en: 'dunum' },
  km2: { ar: 'كم²', en: 'km²' },
  sqft: { ar: 'قدم²', en: 'sq ft' },
  hectare: { ar: 'هكتار', en: 'ha' },
  // length / distance
  m: { ar: 'م', en: 'm' },
  km: { ar: 'كم', en: 'km' },
  // money
  jod: { ar: 'د.أ', en: 'JOD' },
  usd: { ar: '$', en: 'USD' },
  /** the currency of the country chosen in the form's location field (JOD, SAR, AED …) */
  currency: { ar: 'عملة الموقع', en: 'Location currency' },
  // time
  year: { ar: 'سنة', en: 'years' },
  month: { ar: 'شهر', en: 'months' },
  day: { ar: 'يوم', en: 'days' },
  // other
  percent: { ar: '%', en: '%' },
  floor: { ar: 'طابق', en: 'floors' },
  room: { ar: 'غرفة', en: 'rooms' },
  unit: { ar: 'وحدة', en: 'units' },
  car: { ar: 'سيارة', en: 'cars' },
};

/** How a currency code is shown next to an amount, and its name in a field's title. Unknown codes are shown as the code itself. */
export const CURRENCIES: Record<string, { ar: string; en: string; name: { ar: string; en: string } }> = {
  JOD: { ar: 'د.أ', en: 'JOD', name: { ar: 'بالدينار الأردني', en: 'in Jordanian dinars' } },
  SAR: { ar: 'ر.س', en: 'SAR', name: { ar: 'بالريال السعودي', en: 'in Saudi riyals' } },
  AED: { ar: 'د.إ', en: 'AED', name: { ar: 'بالدرهم الإماراتي', en: 'in UAE dirhams' } },
  KWD: { ar: 'د.ك', en: 'KWD', name: { ar: 'بالدينار الكويتي', en: 'in Kuwaiti dinars' } },
  QAR: { ar: 'ر.ق', en: 'QAR', name: { ar: 'بالريال القطري', en: 'in Qatari riyals' } },
  BHD: { ar: 'د.ب', en: 'BHD', name: { ar: 'بالدينار البحريني', en: 'in Bahraini dinars' } },
  OMR: { ar: 'ر.ع', en: 'OMR', name: { ar: 'بالريال العُماني', en: 'in Omani rials' } },
  EGP: { ar: 'ج.م', en: 'EGP', name: { ar: 'بالجنيه المصري', en: 'in Egyptian pounds' } },
  USD: { ar: '$', en: 'USD', name: { ar: 'بالدولار الأمريكي', en: 'in US dollars' } },
};
